var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 0.5,
    stroke: "#5D6F88"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 0.6,
    height: 7,
    rx: 0.3,
    fill: "#5D6F88"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 0.6,
    height: 7,
    rx: 0.3,
    fill: "#5D6F88"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 0.6,
    height: 7,
    rx: 0.3,
    fill: "#5D6F88"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7,
    width: 0.6,
    height: 4,
    rx: 0.3,
    fill: "#5D6F88"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5,
    width: 0.6,
    height: 1,
    rx: 0.3,
    fill: "#5D6F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityReport);
export default __webpack_public_path__ + "static/media/activity_report.e52c7cc0028e20badd3ecd89d93f922c.svg";
export { ForwardRef as ReactComponent };